import React from 'react';

import classes from '../../SalesLogic/InstallImages/installPics.css';

import Pic from '../../../../../../assets/PWRCell.jpg';

const Pic1
 = () => (
     <div className={classes.installImages}>
         <img alt="Generac PWRCell" src={Pic} className={classes.installImg} />
     </div>
 );


export default Pic1;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/EnergyStoragePics/PWRCell.js